import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { UtilitiesProvider } from '../../providers/utilities';
import { Store } from '@ngrx/store';
import { Platform, NavParams, AlertController } from 'ionic-angular';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';
import { TicketData } from '../../providers/ticket';
import * as fromAuth from '../../ngrx/reducers/auth.reducer';
import { Subscription } from 'rxjs/Subscription';
import { has } from 'lodash';
import { DetailShoppingCartHelperComponent } from '../../components/detail-shopping-cart-helper/detail-shopping-cart-helper';
import { TrackingData, _TRACKING_ENTITIES, _TRACKING_ACTIONS } from '../../providers/tracking';
import { ENV } from '@app/env';
import { NavController } from 'ionic-angular/navigation/nav-controller';
import { TranslateCodePipe } from '../../pipes/translate';

const componentName = 'ControlQuantityTicketComponent';

@Component({
  selector: 'app-control-quantity-tickets',
  templateUrl: 'control-quantity-tickets.html'
})
export class ControlQuantityTicketsComponent {

  @Input() ticketId: string;
  @Input() ticket: any;
  @Input() origin: 'ticket' | 'shoppingCart';
  @Input() config: any;
  @Input() uidTrack: string;
  @Output() onChangeFlag = new EventEmitter();
  @ViewChild(DetailShoppingCartHelperComponent) DetailShoppingCartHelperComponent: DetailShoppingCartHelperComponent;

  public btnSlack = document.getElementById("slaask-helper");

  public loaderButton: boolean = false;
  public modelAmount: number = 1;
  public amount: number;
  public ticketInfo: any;
  public selectOptions: any;
  private userSub: Subscription;
  private shoppingSub: Subscription;
  private shoppingCartUser: any = null;
  private userInfo: any;

  constructor(
    private utilities: UtilitiesProvider,
    private ticketProvider: TicketData,
    private store: Store<any>,
    private platform: Platform,
    private analytics: AnalyticsData,
    private trackingData: TrackingData,
    public navParams: NavParams,
    private navCtrl: NavController,
    public alertCtrl: AlertController,
    public translatePipe: TranslateCodePipe,
  ) { }

  ngOnInit() {
    this.calculateSelectOptions();
    this.firstLoadTicket();
  }

  /**
   * Hace la validacion inicial del ticket
   * 1. Valida que el ticket exista basado en el id ingresado
   * 2. Se valida que el ticket encontrado este activo
   * 3. Si el origen es un carrito de compra se valida que exista en el carrito de compra
   */
  private firstLoadTicket() {
    this.ticketProvider.getTicketSnapById(this.ticketId)
      .then(ticket => {
        if (!ticket.val()) {
          return this.presentAlert('The ticket has not been found!');
        }
        if (!ticket.val().state) {
          return this.presentAlert('The ticket has not been found!');
        }

        this.ticketInfo = ticket.val();
        this.validateShoppingCart();
      })
      .catch(() => {
        return this.presentAlert('An error has been presented looking for the ticket!');
      })
  }

  public async calculateSelectOptions() {
    this.selectOptions = {
      title: await this.utilities.translateTextOrObject('Amount selection:')
    }
  }
  /**
   * Hace la validacion de existencia del carrito de compra
   * 1. Se carga el usuario actual y se valida si existe
   * 2. Se carga el carrito de compra del usuario
   * 3. Se valida si el origin es shoppingCart y existe un carrito de compra
   * 4. Si el origin es shoppingCart se valida el ticket exista en el carrito de compra
   */
  private validateShoppingCart() {
    this.userSub = this.store.select(fromAuth.getUser)
      .subscribe(user => {
        if (user) {
          this.shoppingSub = this.ticketProvider.getUserShoppingCart(user.info.id)
            .subscribe((shoppingCart: any) => {
              this.userInfo = user;
              this.shoppingCartUser = shoppingCart;

              if (this.origin === 'shoppingCart') {
                if (has(this.shoppingCartUser, 'tickets')) {
                  return Object.keys(this.shoppingCartUser.tickets).map(key => {
                    if (this.shoppingCartUser.tickets[key].id === this.ticketId) {
                      this.amount = this.shoppingCartUser.tickets[key].sale_amount;
                      this.modelAmount = this.shoppingCartUser.tickets[key].sale_amount;
                      return true;
                    }
                  });
                }
              } else {
                this.amount = this.ticketInfo.min_per_user || 1;
                this.modelAmount = this.ticketInfo.min_per_user || 1;
                return true;
              }
            });
        }
      });
  }

  /**
   * Calcula la interfaz a mostrar segun el dispositivo
   */
  public get amountChangeInterface() {
    if (this.platform.is('mobile')) {
      return 'action-sheet';
    }
    return 'popover';
  }

  /**
   * Se ejecuta cuando se selecciona una opcion en el select
   * @param newAmount
   */
  public selectAmount(newAmount) {
    if (!newAmount) {
      return this.manualChange();
    } else {
      return this.changeValue(newAmount);
    }
  }

  /**
   * Genera el arreglo de las opciones a seleccionar en amount
   */
  public generateMaxAmount() {
    const max = this.ticketInfo.max_per_user > 10 ? 10 : this.ticketInfo.max_per_user;
    const obj = [];
    for (let i = this.ticketInfo.min_per_user; i <= max; i++) {
      obj.push(i);
    }
    return obj;
  }

  /**
   * Cambio manual de cantidad de ticket
   */
  public async manualChange() {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Amount update'),
      message: await this.utilities.translateTextOrObject('Enter the new amount'),
      inputs: [{
        type: 'number',
        name: 'new_amount',
        label: await this.utilities.translateTextOrObject('New amount')
      }],
      buttons: [{
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel',
        handler: () => {
          this.modelAmount = this.amount;
        }
      }, {
        text: await this.utilities.translateTextOrObject('Send'),
        handler: data => {
          if (parseInt(data.new_amount) > 0) {
            this.changeValue(parseInt(data.new_amount, 10));
          } else {
            return false;
          }
        }
      }]
    }).present();
  }

  /**
   * Validacion de cambio de valor
   * 1. Si es origin ticket se valida que la capacidad maxima no sea superada
   * 2. Si es origin shopping cart
   * @param newValue
   */
  public changeValue(newValue: number) {
    if (newValue <= this.ticketInfo.max_per_user && newValue >= this.ticketInfo.min_per_user) {
      if (newValue <= this.ticketInfo.stock) {
        if (this.origin === 'ticket') {
          this.modelAmount = newValue;
          return this.amount = newValue;
        } else if (this.origin === 'shoppingCart') {
          return this.addToCart(newValue);
        }
      } else {
        if (this.origin === 'ticket') {
          this.modelAmount = 1;
        } else if (this.origin === 'shoppingCart') {
          this.modelAmount = this.amount;
        }
        return this.presentToast('The required value is not available in the stock!');
      }
    } else {
      if (this.origin === 'ticket') {
        this.modelAmount = 1;
      } else if (this.origin === 'shoppingCart') {
        this.modelAmount = this.amount;
      }
      return this.presentToast('The value entered is invalid!', 4000, 'bottom');
    }
  }

  public async payNow(newValue: number = null) {
    if (ENV.payment_provider === 'paymentez') {
      this.alertCtrl.create({
        title: await this.translatePipe.transform('Are you sure to make the payment?'),
        message: await this.translatePipe.transform('Payment will be automatically made from your default credit card'),
        buttons: [
          { text: await this.translatePipe.transform('Cancel'), role: 'cancel' },
          {
            text: await this.translatePipe.transform('PAY'), role: 'cancel', handler: () => {
              this.addToCart(newValue, true);
            }
          }
        ]
      }).present();
    } else {
      this.addToCart(newValue, true);
    }

  }

  /**
   * Se hacen todas las validaciones y de pasar se agrega al carrito de compra
   * 1. Se valida disponibilidad si el origin es shoppingCart ya que se valida directamente con el ticket
   */
  public addToCart(newValue: number = null, payNow: boolean = false) {
    if (this.origin === 'ticket') {
      this.loaderButton = true;
      let ticketShoppingCart = null;
      if (has(this.shoppingCartUser, 'tickets')) {
        Object.keys(this.shoppingCartUser.tickets).map(key => {
          if (this.shoppingCartUser.tickets[key].id === this.ticketId) {
            ticketShoppingCart = this.shoppingCartUser.tickets[key];
          }
        });
      }

      if (ticketShoppingCart) {
        if (this.ticketInfo.max_per_user < (this.modelAmount + ticketShoppingCart.sale_amount)) {
          this.modelAmount = 1;
          return this.presentToast('The maximum amount allowed is', 4000, 'bottom', this.ticketInfo.max_per_user);
        }
        if (this.ticketInfo.stock < (this.modelAmount + ticketShoppingCart.sale_amount)) {
          this.modelAmount = 1;
          return this.presentToast('The required value is not available in the stock!');
        }

        return this.addTicketAmount(this.modelAmount + ticketShoppingCart.sale_amount, payNow);

      }
      return this.addTicketAmount(this.modelAmount, payNow);
    }

    if (this.origin === 'shoppingCart') {
      this.loaderButton = true;
      let ticketShoppingCart = null;
      if (has(this.shoppingCartUser, 'tickets')) {
        Object.keys(this.shoppingCartUser.tickets).map(key => {
          if (this.shoppingCartUser.tickets[key].id === this.ticketId) {
            ticketShoppingCart = this.shoppingCartUser.tickets[key];
          }
        });
      } else {
        return this.presentAlert('The ticket has not been found!');
      }

      if (ticketShoppingCart) {
        if (this.ticketInfo.max_per_user < newValue) {
          this.modelAmount = this.amount;
          return this.presentToast('The maximum amount allowed is', 4000, 'bottom', this.ticketInfo.max_per_user);
        }
        return this.addTicketAmount(newValue);
      } else {
        this.modelAmount = this.amount;
        return this.presentAlert(`The user's shopping cart was not found!`);
      }
    }
  }

  /**
   * Paso app-final adicionar/actualizar ticket al carrito de compra
   * @param newAmount
   */
  private addTicketAmount(newAmount: number, payNow: boolean = false) {
    if (!this.userInfo) {
      this.utilities.modal
      this.presentToast('You need to authenticate first!', 3000, 'top');
      const modal = this.utilities.modal.create('auth',
        { enableBackdropDismiss: false, ticket: this.ticket, isModal: true },
        { enableBackdropDismiss: false });
      modal.present();
      modal.onDidDismiss(result => {
        if (result) {
          this.addToCart(newAmount, payNow);
        }
      });
    } else {
      this.ticketProvider.addTicketToShoppingCart(this.userInfo.info.id, this.ticketInfo, newAmount)
        .then(() => {
          this.amount = newAmount;
          this.modelAmount = newAmount;
          this.onChangeFlag.emit(true);
          if (this.payNow) { return true; }
          return this.presentToast('The ticket has been added to the shopping cart!', 3000, 'top');
        })
        .then(() => {
          this.trackingData.trackActivity(this.userInfo.info.id, _TRACKING_ENTITIES.TICKET, this.ticketInfo.id, ENV.client, _TRACKING_ACTIONS.ADD_TO_CART);
          this.analytics.savePageTrackOnFirestore(
            componentName,
            _ACTIONS.updateTicketCart,
            this.uidTrack,
            { catalogId: this.ticketInfo.id, amount: newAmount }
          );
          return true;
        })
        .then(() => {
          if (payNow) {
            this.navCtrl.push('ShoppingTicketCartPage', { isPayNow: true, eventId: "--" });
          }
          this.loaderButton = false;
        })
        .catch(err => {
          this.modelAmount = this.amount;
          this.utilities.consoleErrorAll('error on addTicketAmount', err)
          this.loaderButton = false;
        });
    }
  }

  /**
   * Presenta mensaje tipo toast
   * @param message
   * @param duration
   * @param position
   * @param addTextMessage
   */
  private presentToast(message: string, duration = 4000, position = 'bottom', addTextMessage: string = null): Promise<any> {
    let newMessage = message;
    newMessage += addTextMessage ? ` ${addTextMessage}` : '';

    return this.utilities.setToast(newMessage, duration, position).then(() => {
      this.loaderButton = false;
    });
  }

  /**
   * Presenta mensaje tipo Alert
   * @param message
   * @param title
   */
  private presentAlert(message: string, title: string = 'Alert') {
    return this.utilities.presentAlert(
      title,
      message,
      [{
        text: 'Ok',
        role: 'cancel',
        handler: () => {
          this.loaderButton = false;
        }
      }]
    );
  }

  ngOnDestroy() {
    if (this.shoppingSub) this.shoppingSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/components/control-quantity-tickets/control-quantity-tickets.ts